module.exports = __webpack_public_path__ + "img/reports--icon.ecc7eb76.svg";